document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('media-gallery')) {
    customElements.define(
      'media-gallery',
      class MediaGallery extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            liveRegion: this.querySelector('[id^="GalleryStatus"]'),
            viewer: this.querySelector('[id^="GalleryViewer"]'),
            thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
            trps: this.querySelector('[id^="Slider-Gallery-template"]'),
            trpsQuickadd: this.querySelector('[id^="Slider-Gallery-quickadd-template"]'),
            thumbnail: this.querySelector('.thumbnail-slider'),
          };
          this.mql = window.matchMedia('(min-width: 750px)');
          // if (!this.elements.thumbnails) return;
          if (this.elements.trps != null) {
            this.trpsGain()
          }
          if (this.elements.trpsQuickadd != null) {
            this.trpsGainQuickadd()
          }

          this.elements.thumbnail && this.thumbnail()
          this.initThumbnailSlider();
          this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
          this.elements.thumbnails?.querySelectorAll('[data-target]').forEach((mediaToSwitch, index) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, index));
          });
          if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

          this.variantMediaConfig = this.getVariantMediaConfig();
          if (this.variantMediaConfig && this.dataset.showAllImages === 'false') {
            const selectedVariant = this.variantMediaConfig.variants.find(
              (variant) => String(variant.id) === String(this.variantMediaConfig.selectedVariantId)
            );
            this.filterVariantMedia(selectedVariant?.id, selectedVariant?.featuredMediaId);
          }
        }

        getVariantMediaConfig() {
          const config = this.querySelector('[data-variant-media-config]');
          if (!config) return null;

          try {
            return JSON.parse(config.textContent);
          } catch (error) {
            console.warn('Unable to read the variant media configuration.', error);
            return null;
          }
        }

        getGroupedVariantMediaIds(variant, variantFeaturedMediaId) {
          const mediaIds = (this.variantMediaConfig?.media || []).map(String);
          const variants = this.variantMediaConfig?.variants || [];
          const featuredMediaId = String(variantFeaturedMediaId || variant.featuredMediaId || '');
          const anchorIds = new Set(
            variants
              .map((item) => item.featuredMediaId)
              .filter(Boolean)
              .map(String)
          );

          if (!featuredMediaId || !anchorIds.has(featuredMediaId)) return new Set(mediaIds);

          const selectedAnchorIndex = mediaIds.indexOf(featuredMediaId);
          if (selectedAnchorIndex === -1) return new Set(mediaIds);

          const nextAnchorIndex = mediaIds.findIndex(
            (mediaId, index) => index > selectedAnchorIndex && anchorIds.has(mediaId)
          );
          const groupEnd = nextAnchorIndex === -1 ? mediaIds.length : nextAnchorIndex;
          return new Set(mediaIds.slice(selectedAnchorIndex, groupEnd));
        }

        filterVariantMedia(variantId, variantFeaturedMediaId) {
          if (this.dataset.showAllImages !== 'false' || !this.variantMediaConfig) return;

          const variant = this.variantMediaConfig.variants.find(
            (item) => String(item.id) === String(variantId)
          );
          if (!variant) return;

          const visibleIds = this.getGroupedVariantMediaIds(variant, variantFeaturedMediaId);
          const galleryItems = this.elements.viewer.querySelectorAll('[data-media-id]');

          galleryItems.forEach((item) => {
            const mediaId = item.dataset.mediaId.split('-').pop();
            const isVisible = visibleIds.has(mediaId);
            item.hidden = !isVisible;
            item.setAttribute('aria-hidden', String(!isVisible));
          });

          this.elements.thumbnails?.querySelectorAll('[data-target]').forEach((thumbnail) => {
            const mediaId = thumbnail.dataset.target.split('-').pop();
            const isVisible = visibleIds.has(mediaId);
            thumbnail.hidden = !isVisible;
            thumbnail.setAttribute('aria-hidden', String(!isVisible));
          });

          this.ity?.reloadCells?.();
          this.ity?.resize?.();
          this.ityQuickadd?.reloadCells?.();
          this.ityQuickadd?.resize?.();
          this.elements.viewer.resetPages?.();
          this.elements.thumbnails?.resetPages?.();
        }

        initThumbnailSlider() {
          if (this.dataset.thumbnailSliding !== 'true' || !this.elements.thumbnails) return;
          const list = this.elements.thumbnails.slider;
          const previous = this.elements.thumbnails.querySelector('[name="thumbnail-previous"]');
          const next = this.elements.thumbnails.querySelector('[name="thumbnail-next"]');
          if (!list || !previous || !next) return;
          const vertical = () => this.dataset.thumbnailPosition !== 'bottom';
          const update = () => {
            if (vertical()) {
              const item = Array.from(list.querySelectorAll('.thumbnail-list__item')).find(element => !element.hidden);
              if (item) {
                const style = getComputedStyle(list);
                const height = item.getBoundingClientRect().height * 4 + (parseFloat(style.rowGap) || 0) * 3
                  + (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
                list.style.maxHeight = `${height}px`;
              }
            } else {
              list.style.removeProperty('max-height');
            }
            const position = vertical() ? list.scrollTop : list.scrollLeft;
            const maximum = vertical() ? list.scrollHeight - list.clientHeight : list.scrollWidth - list.clientWidth;
            previous.disabled = position <= 1;
            next.disabled = position >= maximum - 1;
          };
          [previous, next].forEach((button, index) => {
            button.addEventListener('click', () => {
              const distance = (vertical() ? list.clientHeight : list.clientWidth) * (index ? 1 : -1);
              list.scrollBy({ [vertical() ? 'top' : 'left']: distance, behavior: 'smooth' });
            });
          });
          list.addEventListener('scroll', update);
          this.thumbnailResizeObserver = new ResizeObserver(update);
          this.thumbnailResizeObserver.observe(list);
          this.thumbnailMutationObserver = new MutationObserver(update);
          this.thumbnailMutationObserver.observe(list, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
          update();
        }

        disconnectedCallback() {
          this.thumbnailResizeObserver?.disconnect();
          this.thumbnailMutationObserver?.disconnect();
        }

        thumbnail() {
          false && this.elements.thumbnail.querySelectorAll('button').forEach((button) => {
            button.addEventListener('click', (event) => {
              event.preventDefault();
              const mediaId = button.dataset.target;
              this.setActiveMedia(mediaId, false);
            });
          }
          );
        }
        trpsGainQuickadd() {
          this.ityQuickadd = new Flickity(this.elements.trpsQuickadd, {
            pageDots: !this.dataset.desktopLayout.includes('thumbnail'),
            wrapAround: true,
            cellAlign: "left",
            // adaptiveHeight: true
          });
          this.elements.trpsQuickadd.style.display = 'block';
        }
        trpsGain() {
          this.ity = new Flickity(this.elements.trps, {
            pageDots: !this.dataset.desktopLayout.includes('thumbnail'),
            adaptiveHeight: true,
            draggable: false
          });
          this.elements.trps.style.display = 'block';
        }

        onSlideChanged(event) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${event.detail.currentElement?.dataset.mediaId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }

        setActiveMedia(mediaId, prepend, index) {
          const activeMedia =
            this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
            this.elements.viewer.querySelector('[data-media-id]');
          if (!activeMedia) {
            return;
          }
          this.ity?.selectCell(activeMedia);
          this.ityQuickadd?.selectCell(activeMedia);
          this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });
          activeMedia?.classList?.add('is-active');

          if (prepend) {
            activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

            if (this.elements.thumbnails) {
              const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
              activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
            }

            if (this.elements.viewer.slider) this.elements.viewer.resetPages();
          }

          this.preventStickyHeader();
          window.setTimeout(() => {
            if (!this.mql.matches || this.elements.thumbnails) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
            }
            const activeMediaRect = activeMedia.getBoundingClientRect();
            if (activeMediaRect.top > -0.5) return;
            const top = activeMediaRect.top + window.scrollY;
            window.scrollTo({ top: top, behavior: 'smooth' });
          });
          this.playActiveMedia(activeMedia);

          if (!this.elements.thumbnails) return;
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }

        setActiveThumbnail(thumbnail) {
          if (!this.elements.thumbnails || !thumbnail) return;

          this.elements.thumbnails
            .querySelectorAll('button')
            .forEach((element) => element.removeAttribute('aria-current'));
          thumbnail.querySelector('button').setAttribute('aria-current', true);
          if (this.dataset.thumbnailSliding === 'true') {
            const list = this.elements.thumbnails.slider;
            const vertical = this.dataset.thumbnailPosition !== 'bottom';
            list.scrollTo({ [vertical ? 'top' : 'left']: vertical ? thumbnail.offsetTop : thumbnail.offsetLeft, behavior: 'smooth' });
            return;
          }
          if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }

        announceLiveRegion(activeItem, position) {
          const image = activeItem.querySelector('.product__modal-opener--image img');
          if (!image) return;
          image.onload = () => {
            this.elements.liveRegion.setAttribute('aria-hidden', false);
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
            setTimeout(() => {
              this.elements.liveRegion.setAttribute('aria-hidden', true);
            }, 2000);
          };
          image.src = image.src;
        }

        playActiveMedia(activeItem) {
          window.pauseAllMedia();
          const deferredMedia = activeItem.querySelector('.deferred-media');
          if (deferredMedia) deferredMedia.loadContent(false);
        }

        preventStickyHeader() {
          this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
          if (!this.stickyHeader) return;
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }

        removeListSemantic() {
          if (!this.elements.viewer.slider) return;
          this.elements.viewer.slider.setAttribute('role', 'presentation');
          this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
        }
      }
    );
  }
});
